// App.js - WEB
import React, { Component } from "react";
import { StyleSheet, Dimensions, Image } from "react-native";
import { TouchableOpacity } from "react-native-web";

import { updateDimensions, styles } from "./styles";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

var headerHorizontalPadding = 70;
var headerShadowRadius = 5;
var headerShadowOpacity = 0.7;

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    updateDimensions() {
        updateDimensions();
    }

    componentDidMount() {
        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions.bind(this));

        document.body.addEventListener("scroll", () => {
            const headerElement = document.getElementById("addy-main-header");
            const scrollPosition = document.body.scrollTop;

            if (scrollPosition > 500) {
                if (headerElement) {
                    headerElement.style.boxShadow = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
                    headerElement.style.backgroundColor = "#FFFFFF";
                }

            } else {
                if (headerElement) {
                    headerElement.style.boxShadow = "none";
                    headerElement.style.backgroundColor = "#FFFFFF";
                    // headerElement.style.backgroundColor = "#ebf0f8";
                }

            }
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillMount() { }

    onAppLogoClick = () => {
        window.location.href = "/";
    };

    gotToLocalHref = (href) => {
        window.location.href = href;
    };


    MainPage() {
        return (
            <div
                id="addy-main-header"
                className="HeaderContainer"
                style={{
                    height: 81,
                    width: "100%",
                    paddingLeft: styles.basic.headerHorizontalPadding,
                    top: 0,
                    shadowColor: "#000000",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingRight: styles.basic.headerHorizontalPadding,
                    alignItems: "center",
                    shadowOffset: {
                        width: 0,
                        height: 0,
                    },
                    shadowRadius: headerShadowRadius,
                    shadowOpacity: headerShadowOpacity,
                }}>
                <div className="AppLogo" onClick={this.onAppLogoClick}>
                    <Image
                        style={{ width: 26, height: 26, marginRight: 12 }}
                        source={require("./img/logo.png")}
                        resizeMode="contain"
                    />
                    <p className="AppTitleText">Addy AI</p>
                </div>

                <div className="HeaderOptionsDiv" style={{
                    display: "flex", flexDirection: "column",
                    position: "absolute",
                    top: 7,
                    right: 6,
                    // paddingRight: 20,  
                    alignItems: "flex-end"
                }}>

                    <nav class="navbar navbar-expand-lg navbar-light">

                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon navbar-toggler-icon-addy-light"></span>
                        </button>
                        <div class="collapse navbar-collapse" id="navbarNavDropdown" style={{
                            // width: "180px",
                            padding: "10px",
                            marginTop: styles.basic.navMarginTop,
                            boxShadow: styles.basic.navBoxShadow,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            borderRadius: "20px"
                        }}>
                            <ul class="navbar-nav" style={{
                                width: "fit-content",
                            }}>

                                {/* <li class="nav-item">
                                    <a id="addy-nav-link" class="nav-link active" href="#">Pricing</a>
                                </li> */}

                                {/* <li class="nav-item">
                                            <TouchableOpacity style={{
                                                marginRight: "15px"
                                            }} className="SubmitButton" onPress={() => {
                                                window.open(
                                                    "https://calendly.com/michael-addy-ai/addy-ai-demo",
                                                    "_blank"
                                                );
                                            }}>
                                                <p className="SubmitTextHeader" style={{
                                                    backgroundColor: "#8AB4F8",
                                                    color: "black",
                                                    borderRadius: "30px"
                                                }}>Download</p>
                                            </TouchableOpacity>
                                        </li> */}

                                <li class="nav-item">
                                    <a style={{
                                        color: "#151516"
                                    }} id="addy-nav-link" target="_blank" class="nav-link active" href="/about-us">About Us</a>
                                </li>

                                <li class="nav-item">
                                    <a style={{
                                        color: "#151516"
                                    }} id="addy-nav-link" target="_blank" class="nav-link active" href="https://addy.beehiiv.com">Blog</a>
                                </li>

                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle active" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Products
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a id="addy-nav-link" class="dropdown-item" href="/email">Email AI</a>
                                        <a id="addy-nav-link" class="dropdown-item" href="#">Customer Service</a>
                                        <a id="addy-nav-link" class="dropdown-item" href="/products/langdrive">LangDrive</a>
                                    </div>
                                </li>

                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle active" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Resources
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a id="addy-nav-link" class="dropdown-item" href="/how-to-train">How To Train</a>
                                    </div>
                                </li>

                                <li class="nav-item">
                                    <TouchableOpacity style={{
                                        marginRight: "15px"
                                    }} className="SubmitButton" onPress={() => {
                                        window.open(
                                            "https://calendly.com/michael-addy-ai/addy-ai-demo",
                                            "_blank"
                                        );
                                    }}>
                                        <p className="SubmitTextHeader">Request a Demo</p>
                                    </TouchableOpacity>
                                </li>

                                {/* <li class="nav-item">
                                    <a style={{
                                        color: "#151516"
                                    }} id="addy-nav-link" target="_blank" class="nav-link active" href="/">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                                </li> */}

                                

                                {/* <li class="nav-item">
                                    <a style={{
                                        color: "#151516"
                                    }} id="addy-nav-link" target="_blank" class="nav-link active" href="/pricing">Pricing</a>
                                </li> */}
                                {/* <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle active" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Channels
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a id="addy-nav-link" class="dropdown-item" href="#">Email</a>
                                        <a id="addy-nav-link" class="dropdown-item" href="#">Live Chat</a>
                                    </div>
                                </li> */}
                            </ul>
                        </div>
                    </nav>

                    {/* <p onClick={() => this.gotToLocalHref("/pricing")} className="HeaderOptionButton">Pricing</p> */}
                </div>
            </div>
        );
    }

    render() {
        return <div>{this.MainPage()}</div>;
    }
}

export default Header;
